import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import type { ComponentType } from 'react';
import type { EngineComparisonPageProps } from './components/analytics/engine-comparison/EngineComparisonPage';

import { rootRouteRef } from './routes';
import {
  BIAS_FEATURE_FLAG,
  FINDING_VOLUME_DEMO_FEATURE_FLAG,
} from './featureFlags';

export const reportingPlugin = createPlugin({
  id: 'reporting',
  routes: {
    root: rootRouteRef,
  },
  featureFlags: [
    {
      name: BIAS_FEATURE_FLAG,
      description: 'Show the Bias tab on the AI solution analytics page.',
    },
    {
      name: FINDING_VOLUME_DEMO_FEATURE_FLAG,
      description:
        'Show the demo data switch on the Weekly finding volume chart.',
    },
  ],
});

export const ReportingPage = reportingPlugin.provide(
  createRoutableExtension({
    name: 'ReportingPage',
    component: () =>
      import('./components/overview/ReportingPage').then(m => m.ReportingPage),
    mountPoint: rootRouteRef,
  }),
);

export const AnalyticsDetailPage = reportingPlugin.provide(
  createRoutableExtension({
    name: 'AnalyticsDetailPage',
    component: () =>
      import('./components/AnalyticsDetailPage').then(
        m => m.AnalyticsDetailPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const EngineComparisonPage: ComponentType<EngineComparisonPageProps> =
  reportingPlugin.provide(
    createRoutableExtension({
      name: 'EngineComparisonPage',
      component: () =>
        import(
          './components/analytics/engine-comparison/EngineComparisonPage'
        ).then(m => m.EngineComparisonPage),
      mountPoint: rootRouteRef,
    }),
  );
